export default "/images/shortage_qty.png?3a9e3437e1813b541505e4f8fe6e2da7";